import { checkMax } from './checkMax'
import { checkMin } from './checkMin'

export type TRangeParams = { value: number; min: number; max: number }

export const checkRange = ({ value, min, max }: TRangeParams) => {
  const minResult = checkMin(value, min)
  if (minResult) {
    return minResult
  }

  const maxResult = checkMax(value, max)
  if (maxResult) {
    return maxResult
  }

  return ''
}

export const checkRangeAsync = (params: TRangeParams) => Promise.resolve(checkRange(params))
